import type { AboutRepository } from "../../domain/repositories/AboutRepository";
import type { AboutContent } from "../../domain/entities/AboutContent";

export const getAboutContent = async (
  repo: AboutRepository,
): Promise<AboutContent> => {
  return repo.getContent();
};
